<template>
  <div class="blog-page">
    <NavTop/>
    <NavDark/>

    <div class="gray py-3">
      <div class="container">
        <div class="row">
          <div class="colxl-12 col-lg-12 col-md-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/">Hjem</router-link></li>
                <li class="breadcrumb-item"><router-link to="/blog">Blog</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">{{ data?.title }}</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>

    <section v-if="data">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-9 col-md-10 col-sm-12 col-12">
            <div class="article_detail_wrapss single_article_wrap format-standard">
              <div class="article_body_wrap">

                <div class="article_featured_image">
                  <img class="img-fluid" :src="data.image" :alt="data.title">
                </div>

                <div class="article_top_info">
                  <ul class="article_middle_info">
                    <li><a href="#"><span class="icons"><i class="ti-calendar"></i></span>{{ data.date }}</a></li>
                  </ul>
                </div>
                <h2 class="post-title">{{ data.title }}</h2>

                <div v-html="data.content"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section v-else>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <h2>Blogindlæg ikke fundet</h2>
            <p>Det indlæg, du ledte efter, eksisterer ikke.</p>
            <router-link to="/blog" class="btn btn-dark">Tilbage til Blog</router-link>
          </div>
        </div>
      </div>
    </section>

    <FooterTopTwo/>
    <FooterDark/>
    <ScrollToTop/>

  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'

import NavDark from '@/components/navbar/nav-dark.vue';
import NavTop from '@/components/navbar/nav-top.vue';
import FooterTopTwo from '@/components/footer/footer-top-two.vue'
import FooterDark from '@/components/footer/footer-dark.vue'
import ScrollToTop from '@/components/scroll-to-top.vue'

import { useBlog } from '@/services/blogService'
import { updateMeta } from '@/utils/meta.js' // Din centrale SEO funktion

const route = useRoute();
const { getPostBySlug } = useBlog();

const data = ref(null);

// Funktion til at hente data
const loadData = (slug) => {
  const post = getPostBySlug(slug);
  data.value = post;

  // Opdater meta tags
  if (post) {
    updateMeta(post.title, post.description);
  } else {
    updateMeta('Blogindlæg Ikke Fundet', 'Dette blogindlæg kunne ikke findes.');
  }
}

// Hent data når komponenten indlæses
onMounted(() => {
  loadData(route.params.slug);
});

// Overvåg for ændringer i route parameter (hvis man navigerer fra et post til et andet)
watch(() => route.params.slug, (newSlug) => {
  loadData(newSlug);
});
</script>